import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/web.dom-collections.for-each";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
*/
import Immutable from 'immutable';
import NavigationItemRecord from '../../../records/NavigationItemRecord';
import { NAVIGATION_MENU_ID_MORE, NAVIGATION_MENU_ID_PROFILE } from '../id';
var displayTypeRegex = /data-display-type="(.*?)"/;
var deviceFeatureRegex = /data-device-feature="(.*?)"/;

var getDisplayType = function getDisplayType(link) {
  var displayType;

  if (link.samlLinkAttributesAsString) {
    displayType = displayTypeRegex.exec(link.samlLinkAttributesAsString)[1];
  } else if (link.nonSamlLinkAttributesAsString) {
    displayType = displayTypeRegex.exec(link.nonSamlLinkAttributesAsString)[1];
  } else {
    displayType = 'browser';
  }

  return displayType;
};

var getDeviceFeature = function getDeviceFeature(link) {
  var match;

  if (link.samlLinkAttributesAsString) {
    match = deviceFeatureRegex.exec(link.samlLinkAttributesAsString);
  } else if (link.nonSamlLinkAttributesAsString) {
    match = deviceFeatureRegex.exec(link.nonSamlLinkAttributesAsString);
  }

  return match ? match[1] : undefined;
};

var _parseMobileNavigationConfig = function _parseMobileNavigationConfig(navigationPayload) {
  var applicableLinks = navigationPayload.applicableLinks,
      applicableLinksSet = navigationPayload.applicableLinksSet,
      linkConfigMap = navigationPayload.linkConfigMap; // Filter out unused top-level links

  var links = applicableLinks.filter(function (link) {
    return applicableLinksSet.indexOf(link.linkId) >= 0;
  }); // Filter out unused sub-menu links

  links.forEach(function (link) {
    if (link.subLevelHierarchyList) {
      link.subLevelHierarchyList = link.subLevelHierarchyList.filter(function (link) {
        return applicableLinksSet.indexOf(link.linkId) >= 0;
      });
    }
  }); // Update links with properties from linkConfigMap and return

  var navigationItems = links.map(function (link) {
    var mergedLink = Object.assign(link, linkConfigMap[link.linkId]);
    mergedLink.displayType = getDisplayType(mergedLink);
    mergedLink.deviceFeature = getDeviceFeature(mergedLink);

    if (mergedLink.subLevelHierarchyList) {
      mergedLink.subLevelHierarchyList = Immutable.OrderedMap(mergedLink.subLevelHierarchyList.map(function (_subLink) {
        var subLink = Object.assign(_subLink, linkConfigMap[_subLink.linkId]);
        subLink.displayType = getDisplayType(subLink);
        subLink.deviceFeature = getDeviceFeature(subLink);
        return [subLink.linkId, NavigationItemRecord(subLink)];
      }));
    }

    return [mergedLink.linkId, NavigationItemRecord(mergedLink)];
  });
  return Immutable.OrderedMap(navigationItems);
};

var parseMobileNavigationConfig = function parseMobileNavigationConfig(navigationPayload) {
  var menus = [[NAVIGATION_MENU_ID_MORE, _parseMobileNavigationConfig(navigationPayload)]];

  if (navigationPayload.profileMenu) {
    menus.push([NAVIGATION_MENU_ID_PROFILE, _parseMobileNavigationConfig(navigationPayload.profileMenu)]);
  }

  return Immutable.OrderedMap(menus);
};

export default parseMobileNavigationConfig;